import React, { useEffect, useRef, useState } from "react";
import { connectCasinoLive } from "./CasinoLive.connect";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import LoaderContent from "../../components/LoaderContent/LoaderContent";
import { CONFIG } from "../../config/api.config";


const TableCasinoLive = ({ casinoLive, user, balance, slotCasinoPopUp, actions, elementsParams }) => {
    const navigate = useNavigate();
    const containerRef = useRef();
    const location = useLocation();
    const { eventName } = useParams();
    const [iframe_height, setIframeHeigt] = useState(500);
    const [currentCasinoId, setCurrentCasinoId] = useState();
    const [requestSent, setRequestSent] = useState(false);
    const width = elementsParams && elementsParams?.clientWidth ? elementsParams?.clientWidth : window.innerWidth;


    useEffect(() => {
        if((!user)) {
            navigate('/');
        }
    }, [user]);


    useEffect(() => {
        if(containerRef.current) {
            setTimeout(() => {
                containerRef.current.scrollIntoView({ behavior: "smooth" });
            }, 500)
        }
    }, []);

    const handleIframeMessage = (event) => {
        if (event.origin !== 'https://lobbyc.allpanealexch.com') return; // Security: Replace with iframe's origin
        const { iframeHeight } = event.data;
        if (iframeHeight) {
            setIframeHeigt(iframeHeight);
        }
    };

    useEffect(() => {
        window.addEventListener('message', handleIframeMessage);
    
        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);

  

    // if(true) {
    //     return(
    //         <div className="w-full">
    //             <LoaderContent message={'Fetching Game'}/>
    //         </div>
    //     );
    // }

    return(
        <div 
            ref={containerRef}
            className="w-full md:mt-[0px]   lg:overflow-auto"
            style={{minHeight: 'calc(-110px + 100dvh)'}}
        >
            <div className="bg-transparent w-full h-full">
                <div className={`  w-full flex ${CONFIG.showDeposit? 'h-[calc(100dvh-42px)]' : 'h-[100dvh]'} lg:h-[calc(100dvh-54px)]`}>

                <iframe 
                    src={`https://lobbyc.allpanealexch.com/${eventName}/?host_id=diamond222&token=${user?.verifytoken}`}
                    className="w-full h-full flex-grow no-scrollbar"
                    allowFullScreen
                    aria-hidden="true"
                    style={{ height: iframe_height + 100}}
                />

                </div>
            </div>
        </div>
    );

};

export default connectCasinoLive()(TableCasinoLive);
